document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sticky-atc').forEach(function (bar) {
    initStickyAtc(bar);
  });
});

function initStickyAtc(bar) {
  var sectionId = bar.dataset.section;
  var productForm = document.getElementById('product-form-' + sectionId);
  var mainAddToCartBtn = productForm ? productForm.querySelector('[name="add"]') : null;
  var variantSelects = document.getElementById('variant-selects-' + sectionId);

  var stickyImage = document.getElementById('sticky-atc-image-' + sectionId);
  var stickyPrice = document.getElementById('sticky-atc-price-inc-' + sectionId);
  var stickyVariantSelect = document.getElementById('sticky-atc-variant-select-' + sectionId);
  var stickyQuantity = document.getElementById('sticky-atc-quantity-' + sectionId);
  var stickySubmit = document.getElementById('sticky-atc-submit-' + sectionId);
  var stickySubmitText = document.getElementById('sticky-atc-submit-text-' + sectionId);

  var currentVariantId = stickySubmit ? stickySubmit.dataset.variantId : null;

  // 1. Visibility toggle
  if (mainAddToCartBtn) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(mainAddToCartBtn);
  } else {
    window.addEventListener('scroll', function () {
      bar.classList.toggle('is-visible', window.scrollY > 400);
    });
  }

  // 2. Sync sticky bar FROM main picker (main picker changes -> sticky bar updates)
  if (variantSelects) {
    var jsonScript = variantSelects.querySelector('[data-selected-variant]');

    var updateFromVariant = function (variant) {
      if (!variant) return;
      currentVariantId = variant.id;

      if (stickyPrice) {
        stickyPrice.textContent = formatMoney(variant.price);
      }
      if (stickyImage && variant.featured_media) {
        stickyImage.src = variant.featured_media.preview_image.src.replace(/width=\d+/, 'width=100');
      }
      if (stickyVariantSelect) {
        stickyVariantSelect.value = variant.id;
      }
      if (stickySubmit) {
        stickySubmit.dataset.variantId = variant.id;
        stickySubmit.disabled = !variant.available;
      }
      if (stickySubmitText) {
        stickySubmitText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    };

        if (jsonScript) {
      try {
        updateFromVariant(JSON.parse(jsonScript.textContent));
      } catch (e) {}
    }

    document.addEventListener('change', function (event) {
  var target = event.target;

  if (!target.closest('#variant-selects-' + sectionId)) {
    return;
  }

  setTimeout(function () {
    var currentVariantSelects =
      document.getElementById('variant-selects-' + sectionId);

    if (!currentVariantSelects) return;

    var freshScript =
      currentVariantSelects.querySelector('[data-selected-variant]');

    if (!freshScript) return;

    try {
      updateFromVariant(JSON.parse(freshScript.textContent));
    } catch (e) {
      console.error('Could not update sticky variant:', e);
    }
  }, 100);
});
}

 // 3. Sticky bar's dropdown -> main picker
if (stickyVariantSelect) {
  var variantsDataEl = document.getElementById(
    'sticky-atc-variants-' + sectionId
  );

  var allVariants = [];

  if (variantsDataEl) {
    try {
      allVariants = JSON.parse(variantsDataEl.textContent);
    } catch (e) {
      console.error('Could not parse sticky variants:', e);
    }
  }

  // Use document-level event delegation.
  // This survives Shopify replacing/re-rendering the sticky dropdown.
  document.addEventListener('change', function (event) {
    var select = event.target;

    if (!select || select.id !== 'sticky-atc-variant-select-' + sectionId) {
      return;
    }

    var newVariantId = select.value;

    var selectedVariant = allVariants.find(function (v) {
      return String(v.id) === String(newVariantId);
    });

    if (!selectedVariant) {
      console.error('Sticky variant not found:', newVariantId);
      return;
    }

    console.log('Sticky variant selected:', selectedVariant);

    currentVariantId = selectedVariant.id;

    // --------------------------------------------------
    // UPDATE STICKY BAR IMMEDIATELY
    // --------------------------------------------------

    if (stickyPrice && selectedVariant.price != null) {
      stickyPrice.textContent = formatMoney(selectedVariant.price);
    }

    if (stickyImage && selectedVariant.featured_media) {
      stickyImage.src =
        selectedVariant.featured_media.preview_image.src
          .replace(/width=\d+/, 'width=100');
    }

    if (stickySubmit) {
      stickySubmit.dataset.variantId = selectedVariant.id;
      stickySubmit.disabled = !selectedVariant.available;
    }

    if (stickySubmitText) {
      stickySubmitText.textContent = selectedVariant.available
        ? 'Add to cart'
        : 'Sold out';
    }

      });
}

  // 4. Add to cart submit
  if (stickySubmit) {
    stickySubmit.addEventListener('click', function () {
      if (!currentVariantId) return;

      var quantity = stickyQuantity ? parseInt(stickyQuantity.value, 10) || 1 : 1;

      stickySubmit.disabled = true;
      var originalText = stickySubmitText.textContent;
      stickySubmitText.textContent = 'Adding...';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: currentVariantId, quantity: quantity }]
        })
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (err) { throw err; });
          return response.json();
        })
        .then(function () {
          return fetch(window.location.pathname + '?sections=cart-drawer');
        })
        .then(function (response) {
          return response.json();
        })
                .then(function (sections) {
          var newDrawerHtml = sections['cart-drawer'];
          if (newDrawerHtml) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(newDrawerHtml, 'text/html');
            var newDrawer = doc.querySelector('cart-drawer');
            var oldDrawer = document.querySelector('cart-drawer');
             if (newDrawer && oldDrawer) {
              oldDrawer.innerHTML = newDrawer.innerHTML;
              oldDrawer.className = newDrawer.className;
            }
          }

          stickySubmitText.textContent = 'Added!';

          var cartIconLink = document.querySelector('a[href="' + window.Shopify.routes.root + 'cart"], #cart-icon-bubble, [data-cart-icon]');
          if (cartIconLink) {
            cartIconLink.click();
          } else {
            var refreshedDrawer = document.querySelector('cart-drawer');
            if (refreshedDrawer && typeof refreshedDrawer.open === 'function') {
              refreshedDrawer.open();
            }
          }

          setTimeout(function () {
            stickySubmit.disabled = false;
            stickySubmitText.textContent = originalText;
          }, 1500);
        })
        .catch(function (err) {
          console.error(err);
          stickySubmitText.textContent = (err && err.description) || 'Error — try again';
          stickySubmit.disabled = false;
          setTimeout(function () {
            stickySubmitText.textContent = originalText;
          }, 2500);
        });
    });
  }
}

function formatMoney(cents) {
  return '£' + (cents / 100).toFixed(2);
}